<template>
  <nav 
  :class="cssClass"
  class="navbar navbar-expand dashboard-nav ">
    <div class="navbar-nav app-standardpage-tab" :class="parentCustomClass">
      <div v-for="item in navItems" :key="item.code" 
        :class="[ item.code == value ? 'activeTab': null]"
        @click="$emit('input', item.code)"
        class="nav-item text-center mr-2">
          <span v-html="item.label"> </span>
          <font-awesome-icon v-if="item.icon" class="mr-1 ml-2" :icon="['fal', item.icon]" />
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavigationTabs',

  props: ['value', 'navItems', 'centered', 'parentCustomClass'],

  computed: {
     cssClass () {
       if( this.centered != undefined ) {
         return "justify-content-center";
       }
       return null;
     }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.navbar.dashboard-nav {
  padding: 0;
}

.nav-item {
  cursor: pointer;
}

.activeTab {
  border-bottom: 2px solid $primary;
}

div.navbar-nav div:not(:first-child) {
    margin-left : 5px;
}


.navbar.dark-mode {
  color: white;
  background-color: $dark-grey !important;
}


.navbar.light-mode {
  color: #1d1d1d;
  background-color: white !important;
}

</style>
